export const promiseRecord = async <TRecord>(
	promises: { [k in keyof TRecord]: Promise<TRecord[k]> }
): Promise<{ [k in keyof TRecord]: TRecord[k] }> => {
	const resultsAsArray = await Promise.all(
		Object.entries(promises).map(async ([key, promise]) => {
			return [key, await promise];
		})
	);
	return Object.fromEntries(resultsAsArray);
};